import React from 'react';

export const NoLayout = (props) => <React.Fragment>{props.children}</React.Fragment>;
